export * from './EconomicIcon';
